import builderPathInit from '../../util/builder-path-init';

// eslint-disable-next-line max-len
import okendoReviewsBuilderConfig from '../../components/okendo-reviews/okendo-reviews.builder.config';
import OkendoReviews from '../../components/okendo-reviews/okendo-reviews';

const { BuilderPage, getServerSideProps } = builderPathInit({
  model: 'page',
  pathPrefix: 'reviews',
  components: [
    {
      config: okendoReviewsBuilderConfig,
      component: OkendoReviews,
    },
  ],
});

export default BuilderPage;
export { getServerSideProps };
